import Button from '@rio-cloud/rio-uikit/Button';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

interface CreateUserModeStepProperties {
    onCreateUserClick: () => void;
    onAssignUserClick: () => void;
}

export const CreateUserModeStep = memo((props: CreateUserModeStepProperties) => {
    return (
        <div className={'padding-15'}>
            <div className={'padding-15 text-center'}>
                <div className={'text-size-18 line-height-125rel'}>
                    <FormattedMessage id={'intl-msg:createUserDialog.step1.info'} />
                </div>
            </div>
            <div className={'display-flex flex-wrap justify-content-center'}>
                <Button
                    autoTrackingKey='drivers.sidebar.user-dialog.mode.create-user'
                    bsStyle={Button.PRIMARY}
                    className='btn-action text-size-20 margin-10'
                    data-testid={'createUserBtn'}
                    onClick={props.onCreateUserClick}
                >
                    <span className={'rioglyph rioglyph-plus'} />
                    <FormattedMessage id={'intl-msg:createUser'} />
                </Button>
                <Button
                    autoTrackingKey='drivers.sidebar.user-dialog.mode.assign-user'
                    bsStyle={Button.PRIMARY}
                    className='btn-action text-size-20 margin-10'
                    data-testid={'assignUserBtn'}
                    onClick={props.onAssignUserClick}
                >
                    <span className={'rioglyph rioglyph-user'} />
                    <FormattedMessage id={'intl-msg:assignUser'} />
                </Button>
            </div>
        </div>
    );
});

CreateUserModeStep.displayName = 'CreateUserModeStep';
